import { type SxProps, Typography, Box } from "@mui/material";

interface Props {
  children: React.ReactNode;
  sx?: SxProps;
  required?: boolean;
}
export const Label: React.FC<Props> = ({ children, sx, required = false }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography sx={{ fontWeight: "700", mb: 1, ...sx }}>
        {children}
        {required && (
          <Typography
            component="span"
            sx={{
              color: "#d32f2f",
              ml: 0.5,
              fontWeight: "700",
              fontSize: "0.75em",
              verticalAlign: "top",
              position: "relative",
              top: "0.25em",
            }}
          >
            *必須
          </Typography>
        )}
      </Typography>
    </Box>
  );
};
